.port-type [role='radiogroup'] {
    height: 34px;
    display: flex;
    align-items: center;
}
